import React from 'react';
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import ReactDataGrid from 'react-data-grid'
import Loading from './Loading';
import Collapsible from './Collapsible';
import Clipboard from 'react-clipboard.js';
import RowRenderer from './RowRenderer';
import Toolbar from './Toolbar'
import Dry from './Dry'
import swal from 'sweetalert'
import { Menu } from "react-data-grid-addons"
import shortid from 'shortid';

import {
  is_logged_on,
  is_validating
 } from "../helpers"
import {
  show_archive_sidebar_report_actions,
  hide_archive_sidebar_report_actions,
  feed_entries_index,
  feed_entries_um,
  restore_report,
  set_sorting,
  reset_entry_errors,
  batch_update_entries,
  export_report
} from '../actions'

const { ContextMenuTrigger } = Menu

const mapStateToProps = state => {
  return {
    entries: state.entry,
    threshold: state.preference.preferences.maximum_title_length.value,
    current_filters: state.entry.filters,
    fetching_excel: state.report.fetching
  };
};

const mapDispatchToProps = dispatch => {
   return {
     restoreReport: (report_id) => dispatch ( restore_report(report_id, 1, 'minimal') ),
     getEntries: (report_id) => dispatch ( feed_entries_index(report_id) ),
     getFiltered: (report_id, filters) => dispatch ( feed_entries_index(report_id, 1, 50, "", "", filters) ),
     setSorting: (sort, order) => dispatch( set_sorting(sort, order) ),
     getSorted: (report_id, sort, order, filters) => dispatch ( feed_entries_index(report_id, 1, 50, sort, order, filters) ),
     getNextEntries: (report_id, page, per_page, sort, order, filters) => dispatch ( feed_entries_index(report_id, page, per_page, sort, order, filters) ),
     updateRows: (report_id, entry_ids, values) => dispatch( feed_entries_um(report_id, entry_ids, values) ),
     showActions: () => dispatch ( show_archive_sidebar_report_actions() ),
     hideActions: () => dispatch ( hide_archive_sidebar_report_actions() ),
     resetErrors: () => dispatch ( reset_entry_errors() ),
     batchUpdate: (report_id, filters, operations) => dispatch( batch_update_entries(report_id, filters, operations) ),
     exportReport: (report_id) => dispatch( export_report(report_id) )
   }
 }

 class ConnectedEntries extends React.Component {
   constructor () {
     super()
     this.state = {
       calledMoreRowsAtSize: 0,
       maxViewed: 0,
       intervalTimer: false,
       hasActive: false,
       showToolbar: false,
       selectedRows: []
     }
   }

   resetCollapsible() {
     const elem = document.getElementById('collapsible_ul')
     const collapsible = window.M.Collapsible.init(elem);
     collapsible.close()

     this.setState({hasActive: false})
   }

   handleGridRowsUpdated = (e) => {
     const { action, cellKey, rowIds, updated } = e

     if (action === "COLUMN_FILL") {
       return swal({
         title: "Update all items?",
         text: `This action will set the selected cell value to all items that correspond to the selected filtered set.`,
         icon: "warning",
         // buttons: [true, true ],
         buttons: {
           cancel: {
             text: "Cancel",
             value: null,
             visible: true,
             className: "btn red darken-1 waves-effect waves-light",
             closeModal: true,
           },
           confirm: {
             text: "OK",
             value: true,
             visible: true,
             className: "btn red darken-1 waves-effect waves-light",
             closeModal: true
           }
         },
         // dangerMode: true
       }).then(willUpdate => {
         if (willUpdate) {
           const { current_filters, batchUpdate } = this.props
           const { id } = this.props.match.params

           const operations = [{
             field: cellKey,
             operation: "set",
             value: updated[cellKey]
           }]

           batchUpdate( id, current_filters, operations )

         }
       });
     }

     const { id } = this.props.match.params
     this.props.updateRows( id, rowIds, updated )
   };

   componentDidMount() {
     const { id } = this.props.match.params
     this.props.showActions()
     const filters = [
       // {
       //   field: "address",
       //   operator: "!~",
       //   value: '',
       //   key: shortid.generate(),
       // }
     ]
     this.props.getFiltered( id, filters )
   }

   toggleMore() {
     const elem = document.getElementById('collapsible_ul')
     const collapsible = window.M.Collapsible.init(elem);

     const {hasActive} = this.state
     if (hasActive) {
       collapsible.close()
     } else {
       collapsible.open()
     }
     this.setState({hasActive: !hasActive})
   }

   onRowSelect(rows) {
      this.setState({selectedRows: rows})
      if (rows.length > 0) {
        this.setState({showToolbar: true})
      } else {
        this.setState({showToolbar: false})
      }
   }

   componentDidUpdate(prevProps, prevState) {

     const {collapsed} = this.props
     const prevCollapsed = prevProps.collapsed

     if (collapsed !== prevCollapsed) {
       return window.dispatchEvent(new Event('resize'));
     }

   }

   componentWillUnmount() {
     this.props.hideActions()
     if ( this.state.intervalTimer !== false ) {
       clearInterval(this.state.intervalTimer)
     }
   }

   getFiltered(filters) {
     const { id } = this.props.match.params
     this.props.getFiltered(id, filters)
   }

   handleGridSort = (sortColumn, sortDirection) => {
     let sort, order
     if (sortDirection === "NONE") {
       sort="id"
       order="asc"
     } else {
       sort=sortColumn
       order=sortDirection
     }
     this.setState({calledMoreRowsAtSize: 0, maxViewed: 0})
     const { id } = this.props.match.params
     const { filters } = this.props.entries
     this.props.setSorting(sort, order)
     this.props.getSorted(id, sort, order, filters)
   }

   rowGetter = (i) => {
     const rows = this.props.entries.items
     const rowsCount = rows.length
     const { calledMoreRowsAtSize, maxViewed } = this.state

     if ( i === (rowsCount - 20) && maxViewed > (rowsCount - 20) && calledMoreRowsAtSize !== rowsCount ) {
       const { id } = this.props.match.params
       const {page, total_pages, per_page, total_entries} = this.props.entries.pagination
       const {fetching_page} = this.props.entries
       const upper_limit = Math.min( total_entries, page * per_page )

       if ( total_pages > page && rowsCount <= upper_limit && !fetching_page ) {
         this.setState({calledMoreRowsAtSize: rowsCount})
         const new_page = page + 1
         const {sort, order, filters} = this.props.entries
         this.props.getNextEntries( id, new_page, per_page, sort, order, filters )
       }
     }

     if ( i > maxViewed ) {
        this.setState({ maxViewed: i });
     }

     return this.props.entries.items[i]
   }

   render() {

    const { fetching, fetched, errors } = this.props.entries

    if ( !is_validating() && !is_logged_on() ) {
     return <Redirect to="/" />
    }

    if ( !fetching && !fetched && errors !== undefined && errors !== null && errors.length > 0 ) {
      window.M.toast({
        html: errors
      })
      this.props.resetErrors()
      return <Redirect to="/" />
    }

    const { entries } = this.props
    const {report_id, items, keys, master_name, report_name, published, xml_url, xml_pending, xml_status, trash, master_trash, xml_updating, filters, pagination } = entries

    if (fetching || keys === undefined) {
      return <Loading />
    }

    let xmlUrl = ''
    let clip='';
    if (published ) {
      xmlUrl = (<div><span className="bold">Optimized Report Url: </span>{xml_url}</div>)
      if (!xml_pending) {
        clip = (
          <Clipboard data-clipboard-text={xml_url} className="clipboard clip-blue">
          Copy url
          </Clipboard>
        );
      }
    }

    let class1, class2, class3, class4, iconTitle;
    let btnText
    if ( typeof(xml_status) !== "undefined" && xml_status.match(/^outofsync/) ) {
      iconTitle = "XML is out of date"
      if ( xml_updating ) {
        btnText = (xml_pending) ? "...publishing..." : "...updating..."
        iconTitle = "XML is currently updating"
        class4 = (
          <button className="btn waves-effect waves-light"
          disabled="disabled">{ btnText }</button>
        );
      } else if ( xml_pending !== true ) {
        class4 = ''
      } else {
        class4 = ''
      }
      class3 = <i className="material-icons c-yellow mr-10 flex align-center" title={iconTitle}>error_outline</i>
    } else {
      class3 = ''
      class4 = ''
    }

    if (!trash) {
        iconTitle = "" // "Instance not published"
      	class1 = "" // <i className="material-icons c-grey mr-10 flex align-center" title={iconTitle}>cloud_upload</i>;
      	class2 = (
      		<button className="btn light-green waves-effect waves-light"
          disabled={this.props.fetching_excel}
      		onClick={
      			(e) => {
              e.preventDefault()
              if (!this.props.fetching_excel) {
                const report_id = this.props.match.params.id;
                this.props.exportReport(report_id);
              }
            }
      		}>Export XLSX</button>
      )
		} else { //trash
      iconTitle = "Instance is archived"
      class1 = <i className="material-icons c-red flex align-center mr-10" title={iconTitle}>delete</i>;
      if ( ! master_trash ) {
        class2 = (
          <button className="btn red darken-1 waves-effect waves-light" onClick={(e)=>{
            e.preventDefault()
            const report_id = this.props.match.params.id;
            this.props.restoreReport(report_id)

          }}>RESTORE</button>
  			)
      }
    }

    const { toggleMore } = this
    const { collapsed, threshold } = this.props
    const { showToolbar } = this.state

    const wrapperClass = collapsed ? "wrapper collapsedWrapper" : "wrapper"

     return (
      <React.Fragment>

        <Dry />

        <div className="collection with-header">

          <div className="collection-header red darken-1 white-text">
            <span className="flow-text">{ master_name }</span> <span className="smallLink"><Link to={`/projects/${this.props.entries.master_id}`}>Go to project overview</Link></span>
          </div>
          <Collapsible
            hasActive = { this.state.hasActive }
            toggleMore = { toggleMore.bind(this) }
            getFiltered = { this.getFiltered.bind(this) }
            resetCollapsible = {this.resetCollapsible.bind(this)}
            filters = { filters }
            report_id = { report_id }
            account_id = {this.props.entries.account_id}
            columns = { keys }
             />

          <div className="collection-header">
            <div className="flex align-center justify-between">
              <div className="flex flex flex-left">
                <div className="mb-10">
                  <h5 className="mr-10">Report Instance: {report_name}</h5>
                  { xmlUrl }
                  { clip }
                </div>
              </div>
              <div className="flex flex-right">
                {class1}
                {class3}
                {class2}
                {class4}
              </div>
            </div>

            <div className={ wrapperClass }>
              <ReactDataGrid
                columns={ keys }
                enableCellSelect={true}
                enableRowSelect={true}
                headerRowHeight={50}
                minColumnWidth={100}
                minHeight={window.innerHeight - 270}
                onGridRowsUpdated={this.handleGridRowsUpdated}
                onGridSort={this.handleGridSort}
                onRowSelect={this.onRowSelect.bind(this)}
                rowGetter={this.rowGetter}
                rowHeight={100}
                rowRenderer={ <RowRenderer threshold={threshold} /> }
                rowsCount={items.length}
                toolbar={ <Toolbar visible={showToolbar} fetchedRows={items.length} totalRows={pagination.total_entries} selectedRows={this.state.selectedRows} report_id={report_id} /> }
                RowsContainer={ContextMenuTrigger}
              />
            </div>
          </div>
        </div>
       </React.Fragment>
     )
   }

 }

 const Entries = connect(mapStateToProps, mapDispatchToProps)(ConnectedEntries);

 export default Entries;



// WEBPACK FOOTER //
// ./src/js/components/Entries.js